/** @jsx jsx */

import { ComponentProps } from 'react';

import { Forms } from '@zapier/theme';
import { Icon, Grid, Text, TooltipWrapper } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Integration from './Integration';
import { IntegrationType } from './types';

const Styles = {
  root: {
    fontSize: '15px',
  },
  headerRow: css`
    border-bottom: ${Forms.field.border};
  `,
  headerCell: css`
    padding: 8px 15px;
    text-align: left;
    white-space: nowrap;
  `,
  table: css`
    border: ${Forms.field.border};
    border-collapse: collapse;
    border-radius: 3px;
    margin: 16px 0 0 0;
  `,
};

type Props = {
  /** An array of integrations. */
  integrations: Array<IntegrationType>;
  /** Callback when a version is to be viewed by clicking on a row or choosing 'Open' on the dropdown. */
  onViewVersion: ComponentProps<typeof Integration>['onViewVersion'];
  /** Callback when a version is to be viewed by choosing 'View versions' on the dropdown.. */
  onViewVersions: ComponentProps<typeof Integration>['onViewVersions'];
};

function Integrations({ integrations, onViewVersion, onViewVersions }: Props) {
  return integrations.length ? (
    <div css={Styles.root}>
      <Text type="SectionHeader">Integrations</Text>
      <table css={Styles.table}>
        <thead>
          <tr css={Styles.headerRow}>
            <th css={Styles.headerCell}>
              <Text tag="div" textAlign="left" type="Title">
                Name
              </Text>
            </th>
            <th css={Styles.headerCell}>
              <Text tag="div" textAlign="left" type="Title">
                Status
              </Text>
            </th>
            <th css={Styles.headerCell}>
              <Grid
                alignItems="center"
                columns="repeat(2, max-content)"
                gap="7px"
              >
                <Text tag="span" textAlign="left" type="Title">
                  Version
                </Text>
                <TooltipWrapper
                  allowMultilineTooltip={true}
                  content="Published or latest version"
                >
                  {() => (
                    <Icon aria-label="Help" name="alertInfoFill" size={18} />
                  )}
                </TooltipWrapper>
              </Grid>
            </th>
            <th aria-label="Integration Actions" css={Styles.headerCell} />
          </tr>
        </thead>
        {integrations.map(itg => (
          <Integration
            integration={itg}
            key={itg.id}
            onViewVersion={onViewVersion}
            onViewVersions={onViewVersions}
          />
        ))}
      </table>
    </div>
  ) : null;
}

export default Integrations;
